import './Terms.scss'

const Terms = () => {
  return (
    <div className="terms-wrapper">
      <div className="container mx-auto">
        <h1>Summary of Comment8’s Terms of Service</h1>

        <p>These Terms of Service (“Terms”) are part of the User Agreement – a legally binding contract governing your
          use of Comment8, a Subsidiary property of Sokhey LLC. <strong>You should read these Terms of Service (“Terms”)
            in full, but here are a few key things you should take away:</strong></p>

        <ul>
          <li><strong>Intellectual Property Licenses in Comment8's Terms:</strong> You retain full ownership and rights
            to any Content you post or share on or with Comment8. However, by doing so, you grant us a broad,
            royalty-free license to distribute your Content globally and allow others to do the same. Similarly,
            Comment8 grants you a license to use the software provided as part of the Services, such as the Comment8
            mobile application, strictly for the purpose of accessing and enjoying the features of the platform.
          </li>
          <li><strong>Advertising on the Comment8 Platform:</strong> By using Comment8 Services, you acknowledge that
            Comment8, along with our third-party providers and partners, may display advertisements as part of your
            experience.
          </li>
          <li><strong>Your Use of Comment8 Services is at Your Own Risk:</strong> The Services are provided on an “AS
            IS” and “AS AVAILABLE” basis, and Comment8 disclaims all warranties, responsibilities, and liabilities to
            the fullest extent permitted by law. You may encounter offensive or harmful content shared by other users.
            Additionally, the Services may evolve over time, and Comment8 reserves the right to modify, limit, or
            discontinue access to the platform or specific features for you or other users at any time.
          </li>
          <li><strong>Responsibility for Content and Service Use:</strong> When using the Services and posting Content,
            you are required to adhere to this User Agreement, its associated policies, and all applicable laws. You are
            solely responsible for your actions and the Content you share on the platform.
          </li>
          <li><strong>Compliance with Comment8's Acceptable Use Policy:</strong> You are required to use the Services
            only through the authorized and publicly available interfaces provided by Comment8. For instance, scraping
            the platform without prior written consent from Comment8, bypassing technical restrictions, or attempting to
            interfere with the functionality of the Services is strictly prohibited.
          </li>
          <li><strong>Comment8's Enforcement Rights:</strong> Comment8 reserves the right to take appropriate action if
            you violate these terms, including but not limited to removing your Content, restricting its visibility,
            suspending or terminating your access to the platform, or pursuing legal action. Additionally, Comment8 may
            suspend or terminate your account for reasons such as extended inactivity, potential legal risks, or
            operational and commercial considerations.
          </li>
          <li><strong>You have remedies and redress mechanisms, but our liability is limited:</strong> You have a right
            to terminate this agreement at any time by deactivating your account and discontinuing use of the Services.
            Note that we will not be liable for certain types of damages as described in the agreement, and in any
            event, our aggregate liability shall not exceed the greater any amount you paid us, if any, in the past six
            months for the Services giving rise to the claim. Further, if you believe that your Content has been copied
            in a way that constitutes copyright infringement, the reporting process is detailed in these Terms.
          </li>
        </ul>

        <p>Please also note that these Terms incorporate our Privacy Policy as well as other terms applicable to your
          use of the Services and your Content. Finally, these Terms may vary depending on where you live, but in any
          case, you must be at least 13 years old to use Comment8.</p>

      </div>
    </div>
  );
};
export default Terms
